exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\r\nthead th:nth-child(1) {display: none;}*/\r\n/*.dList .ui-datatable .ui-datatable-header{background-color: yellow !important; display: none !important;}*/\r\n\r\n/*.ui-datatable-header th .ui-chkbox  { display:none !important;}*/\r\n/*.ui-state-default .ui-unselectable-text .ui-selection-column {display: none !important;}*/\r\n\r\n.table-no-select-all .ui-chkbox-all {\r\n  display: none !important;\r\n}\r\n\r\n.policyTable .ui-datatable-scrollable-body {\r\n  overflow:visible !important;\r\n}\r\n\r\n.policyTable thead th p-dtcheckbox { display: none !important;}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/policy/policy_config_new.css
// module id = ../../../../../src/app/page/policy/policy_config_new.css
// module chunks = 1